import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { AppState } from '@app/state/app.state';

@Component({
  selector: 'app-renewals',
  templateUrl: './renewals-index.component.html',
  styleUrls: ['./renewals-index.component.scss'],
})
export class RenewalsIndexComponent implements OnInit {
  constructor(private store: Store<AppState>, private router: Router) {}

  ngOnInit(): void {}

  search($event) {}
}
